import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "percentagePipe" })
export class PercentagePipe implements PipeTransform {
  transform(value: number, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return 'N/A';

    return value.toFixed(decimals) + '%';
  }
}
